import { render, staticRenderFns } from "./dashboardHome.vue?vue&type=template&id=a20b6a24&scoped=true"
import script from "./dashboardHome.vue?vue&type=script&lang=js"
export * from "./dashboardHome.vue?vue&type=script&lang=js"
import style0 from "./dashboardHome.vue?vue&type=style&index=0&id=a20b6a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20b6a24",
  null
  
)

export default component.exports